// extracted by mini-css-extract-plugin
export default {"clientPicker":"ClientPicker-module__clientPicker--nz9qv"};